import React, { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { SnackbarContent } from "@mui/material";

export default function Disclaimer() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      action={
        <IconButton color="inherit" size="small" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      }
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      message={t("moodboards.disclaimer")}
    >
    </Snackbar>
  );
}
